import './dataProtection.scss';

const DataProtection = () => {
    return (
      <div className="dataProtection">
        <h1>Защита данных</h1>
      <p>
        Сайт <strong>zaym-online.org</strong> (далее в тексте - Сайт).
      </p>
      <p>
        <strong>Посетитель</strong> - физическое лицо, которое в Интернете посещает Сайт (zaym-online.org).
      </p>
      <p>
        Ваша конфиденциальность, безопасность очень важна для нас. Любая информация, полученная от Посетителя, не будет раскрыта и оценивается как конфиденциальная, она не будет продана или использована иным образом, причинив вред Посетителям.
      </p>
      <p>
        Посетители Сайта имеют право без ограничений, и введя данные, посещать разделы Сайта и ознакомляться с информационными материалами.
      </p>
      <p>
        При посещении Сайта, информация об IP адресе Посетителя, дате и времени будет использована для анализа тенденции Посетителей для внутреннего пользования.
      </p>
      <p>
        Посещая Сайт, его Посетитель соглашается с условиями Cookies, Защиты данных, Пользования и э-почты. Принимается, что посетитель с данными условиями ознакомился и принял их.
      </p>
      <p>
        Прекратите использование Сайта, если у Вас есть претензии к правилам и не приемлемо их содержание, ссылка (и) на авторские права.
      </p>
      <p>
        Любая информация, полученная от Посетителя, не будет раскрыта и оценивается как конфиденциальная, она не будет продаваться или использоваться иным образом, причинив вред Посетителям.
      </p>
        </div>
    )
}

export default DataProtection;